<template>
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link"><a :href="`${$SiteUrl}/loja`" class="fa fa-home" rel="nofollow"></a></li>
                    <li class="item-link"><span>login</span></li>
                </ul>
            </div>
            <div class="row">
                <div class="main-content-area">
                    <div class="wrap-login-item ">
                        <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
                            <div class="login-form form-item ">
                                <form @submit.prevent="login" name="frm-login">
                                    <fieldset class="wrap-title">
                                        <h3 class="form-title">Já sou cadastrado</h3>
                                    </fieldset>
                                    <fieldset class="wrap-input">
                                        <label for="frm-login-uname">CNPJ <span class="required">*</span></label>
                                        <input type="text" id="frm-login-uname" name="email" v-model="formLogin.usuario" placeholder="CNPJ" :class="{ 'is-invalid': !isUserValid.status && formLogin.attemptSubmit }" autofocus>
                                        <span v-if="!isUserValid.status && formLogin.attemptSubmit" class="invalid-feedback">{{ isUserValid.message }}</span>
                                    </fieldset>
                                    <fieldset class="wrap-input">
                                        <label for="frm-login-pass">Senha <span class="required">*</span></label>
                                        <input type="password" id="frm-login-pass" name="pass" v-model="formLogin.senha" placeholder="Senha" :class="{ 'is-invalid': !isPasswordValid.status && formLogin.attemptSubmit }">
                                        <span v-if="!isPasswordValid.status && formLogin.attemptSubmit" class="invalid-feedback">{{ isPasswordValid.message }}</span>
                                    </fieldset>
                                    <fieldset class="wrap-input">
                                        <a class="link-function" :href="`${$SiteUrl}/recuperar-senha`" title="Esqueceu a senha ?">Esqueci a senha</a>
                                        <!-- <a class="link-function" style='margin-left: 275px; padding-right: 0px;' :href="`${$SiteUrl}/primeiro-acesso`" title="Primeiro acesso?">Primeiro acesso</a> -->
                                    </fieldset>
                                    <fieldset>
                                        <div v-if="!formLogin.authentication.status && formLogin.authentication.error" class="alert alert-danger text-center" role="alert">
                                            <b><span v-html="formLogin.authentication.error"></span></b>
                                        </div>
                                        <div v-if="formLogin.authentication.status && formLogin.authentication.success" class="alert alert-success text-center" role="alert">
                                            <b>{{ formLogin.authentication.success }}</b>
                                        </div>
                                    </fieldset>
                                    <input type="submit" class="btn btn-submit" value="Entrar" name="submit" v-bind:disabled="formLogin.processing">
                                    <!-- <button class="btn primary-button pull-right" type="button" data-toggle="modal" data-target="#order-type-modal">
                                        <i class="fa fa-file-text fa-lg"/>
                                    </button> -->
                                </form>
                            </div>
                        </div>
                        <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
                            <div class="register-form form-item ">
                                <form @submit.prevent="register" name="frm-login" method="get">
                                    <fieldset class="wrap-title">
                                        <h3 class="form-title">Ainda não tenho cadastro</h3>
                                    </fieldset>
                                    <fieldset class="wrap-input">
                                        <label for="frm-reg-lname">CNPJ <span class="required">*</span></label>
                                        <input type="text" id="frm-reg-lname" name="reg-lname" v-model="formRegister.cnpj" v-mask="'##.###.###/####-##'" placeholder="CNPJ *" :class="{ 'is-invalid': !isCnpjValid.status && formRegister.attemptSubmit }">
                                        <span v-if="!isCnpjValid.status && formRegister.attemptSubmit" class="invalid-feedback">{{ isCnpjValid.message }}</span>
                                    </fieldset>

                                    <input type="submit" class="btn btn-sign" value="Avançar" name="sign">
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modal-contrato" class="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="row">
                                <div v-if="messageContrato == 'SEMCONTRATOADMINISTRADOR' " class="col-md-6">
                                    <p><a v-on:click="gerarcontrato" class="btn btn-success btn-block">Gerar Contrato</a></p>
                                </div>

                                <div v-if="messageContrato == 'SEMCONTRATOADMINISTRADOR'" class="col-md-6">
                                    <p><a v-on:click="continuarSemContrato" class="btn btn-success btn-block">Continuar sem gerar contrato</a></p>
                                </div>
                            </div>

                            <h4 class="modal-title">Atenção</h4>
                        </div>
                        <div class="modal-body">
                            <p class="lead">Em cumprimento a legislações vigentes, a ALDO atualizou seu Contrato Comercial com Revenda, especialmente para incorporar:</p>
                            <ul class="list-unstyled" style="line-height: 2">
                                <li><span class="fa fa-check text-success"></span>A Lei Geral de Proteção de Dados (LGPD)</li>
                                <li><span class="fa fa-check text-success"></span>A Lei Anticorrupção (Código de Ética e Conduta)</li>
                                <li><span class="fa fa-check text-success"></span>A necessidade das normas ABNT/Inmetro</li>
                            </ul>
                            <p>Todas as Revendas terão um prazo de <strong>30 dias</strong> para a assinatura do Novo Contrato Comercial, período após o qual haverá bloqueio automático da navegação no “Site” e no “Direct-Client”.</p>
                            <p>O Novo Contrato Comercial deve ser assinado inclusive por quem recentemente assinou o anterior manualmente.</p>
                            <p>A ALDO trouxe um novo processo de assinatura, que agora é completamente digital e leva menos de um minuto! São 5 passos simples e rápidos.</p>
                            <ul class="list-unstyled" style="line-height: 2">
                                <li><strong>1) </strong>Informe seu CNPJ e clique em avançar</li>
                                <li><strong>2) </strong>Confira sua razão social e selecione o sócio que ira assinar o contrato</li>
                                <li><strong>3) </strong>Clique em "GERAR CONTRATO"</li>
                                <li><strong>3) </strong>Confira os dados do sócio</li>
                                <li><strong>4) </strong>Você receberá o Token por email imediatamente; digite em tela o Token de 6 dígitos recebidos neste email</li>
                            </ul>
                            <p>Pronto! O documento já está assinado e sua revenda já fica liberada para seguir com as operações junto à ALDO, inclusive as de Venda Direta.</p>
                            <p>Você pode baixar sua cópia assinada através do menu <strong>“Minha Conta” -> “Contrato de Venda Direta assinado”</strong>.</p>
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                                <div v-if="messageContrato == 'SEMCONTRATOADMINISTRADOR'" class="col-md-6"><p><a v-on:click="gerarcontrato" class="btn btn-success btn-block">Gerar Contrato</a></p></div>
                                <div v-if="messageContrato == 'SEMCONTRATOADMINISTRADOR'" class="col-md-6"><p><a v-on:click="continuarSemContrato" class="btn btn-success btn-block">Continuar sem gerar contrato</a></p></div>
                                <div v-if="qtdeDiasExpiracaoContrato > 0" class="col-md-6"><p><button v-on:click="lembrarmaistarde" type="button" class="btn btn-warning btn-block" data-dismiss="modal">Mais Tarde!</button></p></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modal-termo" class="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Termo de Uso</h4>
                        </div>
                        <div class="modal-body">
                            <p><strong>Ao acessar, navegar e operar neste “SITE” e no “DIRECT-CLIENT”, o USUÁRIO declara aceitar e concordar com:</strong></p>
                            <ul class="list-unstyled" style="line-height: 2">
                                <li><span class="fa fa-check text-success"></span><a href="https://www.aldo.com.br/termos-de-uso" target="_blank"> Termo de Uso</a></li>
                                <li><span class="fa fa-check text-success"></span><a href="https://www.aldo.com.br/blog/politica-de-privacidade" target="_blank"> Política de Privacidade</a></li>
                                <li><span class="fa fa-check text-success"></span><a href="https://www.aldo.com.br/blog/codigo-de-conduta-e-etica-politica-de-compliance" target="_blank"> Código de Ética e Conduta – Compliance</a></li>
                                <li><span class="fa fa-check text-success"></span><a href="https://www.aldo.com.br/portais/aldo-crazy-card/#condicoes-comerciais" target="_blank"> Condições Comerciais</a></li>
                                <li><span class="fa fa-check text-success"></span><a href="https://www.aldo.com.br/termo-de-atendimento" target="_blank"> Termo de Atendimento</a></li>
                                <li><span class="fa fa-check text-success"></span> O Contrato Comercial com Revendas</li>
                                <li><span class="fa fa-check text-success"></span> Recebimento de registros e divulgações em formato eletrônico</li>
                            </ul>
                            <p>O USUÁRIO entende que os Termos, Códigos, Condições e Contratos acima descritos têm a natureza jurídica de um contrato e concorda que o Aceite implicará na vinculação da ALDO e do USUÁRIO aos seus termos e condições.</p>
                            <p>Recomendamos que seja impressa uma cópia destes documentos para futura referência.</p>

                        </div>
                        <div class="modal-footer">
                            <div id='app'>
                                <label for='terms' style="font-size: 15px; padding-inline-end: 240px;">
                                    <input style="margin: 5px" id='terms' type="checkbox" v-model='terms' />Declaro ter lido e aceito todos os termos
                                </label>
                                <p></p>
                                <button :disabled='isDisabled' v-on:click="gerartermo" class="btn btn-info btn-block">EU ACEITO</button>
                            </div>

                            <!-- <div class="row">
                                <div class="col-md-12"><p><a v-on:click="gerartermo" class="btn btn-info btn-block">EU ACEITO</a></p></div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- POP-UP AVALIAÇÃO META PLR -->
            <div id="modal-avaliacao" class="modal" tabindex="-1" role="dialog" style="top: 50px">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="btn-close-sol-agora" onclick="location.href = `/loja`"><i class="fa fa-close"></i></button>
                            <h4 class="modal-title">DESAFIO 5X5</h4>
                        </div>

                        <div class="modal-body">
                            <a href="https://www.aldo.com.br/loja/campanhas/desafio5x5"><img src="/assets/images/POPUPPROMOCAO.png" alt="DESAFIO 5X5" width="100%"></a>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div id="modal-cadastro-solagora" class="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <img src="/assets/images/cadastro-solagora.png" alt="" />
                        <button type="button" class="btn-close-sol-agora" onclick="location.href = `/loja`"><i class="fa fa-close"></i></button>
                        <button type="button" class="btn-sol-agora" @click="gravarClick" onclick="window.open('https://integrator.solagora.com.br/integrator', '_blank'); location.href = `/loja`">Clique aqui</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal-black-friday-solagora" class="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <img src="/assets/images/blackfriday-solagora.jpg" alt="" />
                        <button type="button" class="btn-close-sol-agora2" onclick="location.href = `/loja`"><i class="fa fa-close"></i></button>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <!-- <OrderTypeModal/> -->
    </main>
</template>

<style scoped>
    #modal-cadastro-solagora .modal-dialog {
        width: 400px;
        margin: 50px auto;
    }

    #modal-cadastro-solagora .modal-body {
        padding: 0px;
    }

    #modal-cadastro-solagora .modal-content {
        background: transparent;
        box-shadow: none;
        border: none;
    }

    .btn-close-sol-agora,
    .btn-close-sol-agora2 {
        position: absolute;
        right: 13px;
        top: 14px;
        border-radius: 50%;
        color: #d4d4d4;
        background: #f5f5f5;
        outline: 0;
        white-space: nowrap;
        user-select: none;
        border: 0;
    }

    .btn-close-sol-agora2 {
        font-size: 15px;
        color: #ff6c04;
        right: 18px;
        top: 18px;
    }

    .btn-sol-agora {
        position: absolute;
        left: 27px;
        top: 448px;
        padding: 11px 25px;
        border-radius: 5px;
        font-weight: 700;
        color: white;
        background: #3c38d9;
        outline: 0;
        white-space: nowrap;
        user-select: none;
        border: 0;
    }

    @media (max-width: 400px) {
        #modal-cadastro-solagora .modal-dialog {
            width: 320px;
            margin: 20px auto;
        }

        .btn-close-sol-agora {
            position: absolute;
            right: 10px;
            top: 11px;
            border-radius: 50%;
        }

        .btn-sol-agora {
            position: absolute;
            left: 21px;
            top: 357px;
            padding: 10px 19px;
            border-radius: 5px;
            font-size: 12px;
        }
    }
</style>

<script>
    import { async } from 'q';
    import SolAgoraService from "@/services/SolAgoraService";
    import axios from 'axios';

    export default {
        name: 'login',
        props: {
            msg: String
        },
        components: {
            //OrderTypeModal
        },
        data() {
            return {
                terms: false,
                formLogin: {
                    usuario: '',
                    senha: '',
                    attemptSubmit: false,
                    authentication: {},
                    processing: false,
                },
                formRegister: {
                    cnpj: '',
                    attemptSubmit: false
                },
                formRegisterFull: {
                    cnpj: '',
                    razaoSocial: ''
                },
                messageContrato: '',
                qtdeDiasExpiracaoContrato: 0
            }
        },

        computed: {
            isDisabled: function () {
                return !this.terms;
            },
            isUserValid: function () {
                let response = {};

                if (!this.formLogin.usuario) {
                    response.status = false;
                    response.message = "Por favor, preencha o campo acima"
                } else {
                    this.formLogin.authentication = {}
                    response.status = true;
                }

                return response;
            },
            isPasswordValid: function () {
                let response = {};

                if (!this.formLogin.senha) {
                    response.status = false;
                    response.message = "Por favor, preencha o campo acima"
                } else {
                    this.formLogin.authentication = {}
                    response.status = true;
                }

                return response;
            },
            isCnpjValid: function () {
                const re = /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})/;
                const cnpj = this.formRegister.cnpj;

                let response = {};

                if (!cnpj || !re.test(cnpj) || !this.testCnpj(cnpj)) {
                    response.status = false;
                    response.message = "Por favor, preencha o CNPJ corretamente"
                } else {
                    response.status = true;
                }

                return response;
            }
        },
        methods: {
            login: function () {
                // Notifica que submit já foi realizado
                this.formLogin.attemptSubmit = true;

                // Verifica se os dados são válidos
                if (this.isUserValid.status && this.isPasswordValid.status) {
                    this.formLogin.processing = true;
                    const user = this.formLogin.usuario;
                    const password = this.formLogin.senha;

                    // Caso os dados sejam válidos, realiza a autenticação com o servidor
                    this.authenticate(user, password);
                }
            },
            lembrarmaistarde: function () {
                location.href = `${this.$SiteUrl}/loja`
            },
            gerartermo: function () {
                let response = {
                    status: false,
                    error: '',
                    success: ''
                }
                var self = this;
                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        $("#modal-termo").modal("hide");
                        window.location.href = `${this.$SiteUrl}/loja/minha-conta`;
                    }
                }
                xhr.open("POST", this.$apiUrl + "Login.svc/aceitetermo");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({ usuario: this.formLogin.usuario }))
            },
            gerarcontrato: function () {
                if (sessionStorage.getItem('cnpj') !== null) {
                    sessionStorage.removeItem('cnpj');
                }
                location.href = `${this.$SiteUrl}/loja/gerarcontrato`
            },
            continuarSemContrato: function () {

                location.href = `${this.$SiteUrl}/loja`
            },
            authenticate(user, password) {
                // TODO: Fazer requisição ajax e retornar o erro/sucesso e o status (true/false)
                // TODO: Retornar resposta da autenticação como no exemplo abaixo

                let response = {
                    status: false,
                    error: '',
                    success: ''
                }
                var self = this;
                var xhr = new XMLHttpRequest();
                xhr.onload = async () => {
                    console.log('erro login')
                    if (xhr.status == 200) {
                        this.cleanAgendamentoLocal()

                        var obj = JSON.parse(xhr.response);
                        var message = obj.Item2.split('-')[0];
                        self.messageContrato = message;
                        self.qtdeDiasExpiracaoContrato = obj.Item2.split('-')[1];

                        this.carregarRegrasAvisos()

                        //if (message == "CLIENTENOVO") {
                            //location.href = `${this.$SiteUrl}/loja/gerarcontrato`
                            //return;
                        //}

                        if (message == "SEMCONTRATOADMINISTRADOR" || message == "SEMCONTRATO") {
                            $("#modal-contrato").modal("show");
                            localStorage.setItem('waitingLogin', 'true');
                            this.formLogin.authentication = response;
                            return;
                        }

                        if (obj.Item2.split('-')[2] === "SEMTERMODEUSO" || obj.Item2.split('-')[1] === "SEMTERMODEUSO") {
                            $("#modal-termo").modal("show");
                            return;
                        }

                        response.status = true
                        response.success = 'Login realizado com sucesso'
                        localStorage.setItem('waitingLogin', 'true');
                        this.formLogin.authentication = response;

                        if (obj.Item2.split('-')[2] === "AVALIAR" || obj.Item2.split('-')[1] === "AVALIAR") {
                            $("#modal-avaliacao").modal("show");
                            return;
                        }

                        if (new Date() < new Date(Date.parse('2023-09-30'))) {
                            $("#modal-avaliacao").modal("show");
                            return;
                        }

                        try {
                            if (new Date() < new Date(Date.parse('2022-12-01'))) {
                                const res = await SolAgoraService.CheckIntegrator({ apiUrl: this.$apiUrl, cnpj: this.formLogin.usuario })
                                const active = res.data.Active;

                                if (active) {
                                    $("#modal-black-friday-solagora").modal("show");
                                    return;
                                }
                            }
                        }
                        catch { }

                        try {
                            const res = await SolAgoraService.CheckIntegratorPreRegistration({ apiUrl: this.$apiUrl, cnpj: this.formLogin.usuario })
                            const precadastro = res.data.PreRegistration;

                            if (precadastro) {
                                $("#modal-cadastro-solagora").modal("show");
                                return;
                            }
                        }
                        catch { }

                        if (!this.$route.query.redirectTo)
                            location.href = `${this.$SiteUrl}/loja`
                        else {
                            var linkref = this.$route.query.redirectTo;
                            if (linkref.indexOf('/loja') === -1) {
                                linkref = linkref.replace("https://www.aldo.com.br/", "https://www.aldo.com.br/loja")
                            }
                            location.href = linkref
                        }
                    }
                    else {
                        var obj = JSON.parse(xhr.response);
                        var message = obj.Item1;

                        if(message == "Notamos que sua senha expirou, e para manter sua conta sempre segura, você precisa atualizá-la. Mas não se preocupe, é rapidinho!")
                        {
                            message += `<br /><a href="${this.$SiteUrl}/assets/pdf/guia_alterar_senha_user_interno.pdf" target="_blank">Clique aqui para ver como.</a>`
                        }

                        response.status = false;
                        response.error = message.replace(/[\\"]/g, '');
                        this.formLogin.processing = false;
                    }
                }
                
                xhr.onerror = () => {
                    console.log('erro login')
                    response.status = false;
                    var obj = xhr.response;
                    var message = obj.Item1;
                    response.error = message || xhr.statusText;
                    this.formLogin.processing = false;
                };

                xhr.open("POST", this.$apiUrl + "Login.svc/login");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({ usuario: this.formLogin.usuario, senha: this.formLogin.senha }))

                // Caso a autenticação seja válida, redireciona para a página.
                // Caso seja inválida, o erro é exibido automaticamente de acordo com o status atribuído à variável de autenticação
                this.formLogin.authentication = response;
            },

            async gravarClick() {
                await SolAgoraService.IntegratorClick({ apiUrl: this.$apiUrl, cnpj: this.formLogin.usuario })
            },

            register: function (e) {
                // Notifica que submit já foi realizado
                this.formRegister.attemptSubmit = true;

                // Verifica se os dados são válidos
                if (this.isCnpjValid.status) {
                    // Usa expressão regular para remover todos os characteres do CNPJ que não sejam número
                    const cnpj = this.formRegister.cnpj.replace(/[^0-9]/g, '');

                    var xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        if (xhr.status == 200) {
                            var result = JSON.parse(xhr.responseText);
                            if (result.Item1 == false) {
                                // Redireciona para a página de cadastro simplificado
                                this.$router.push(`/cadastro-simplificado/${cnpj}`);
                            } else if (result.Item2 == 0) {
                                // Redireciona para a página de cadastro
                                this.$router.push(`/cadastro/${cnpj}`);
                            } else {
                                swal({
                                    title: "CNPJ já cadastrado no sistema",
                                    icon: "warning"
                                })
                            }
                        } else {
                            swal({
                                title: "Erro ao verificar CNPJ",
                                icon: "warning"
                            })
                        }
                    }

                    xhr.open("POST", this.$apiUrl + "ClientePre.svc/verificacnpj");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(JSON.stringify({ cnpj: cnpj }))
                }
            },
            testCnpj: function (c) {
                var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

                if ((c = c.replace(/[^\d]/g, "")).length != 14)
                    return false;

                if (/0{14}/.test(c))
                    return false;

                for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
                if (c[12] != (((n %= 11) < 2) ? 0 : 11 - n))
                    return false;

                for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
                if (c[13] != (((n %= 11) < 2) ? 0 : 11 - n))
                    return false;

                return true;
            },
            carregarRegrasAvisos: async function () {
                const key = 'regrasAvisos'
                localStorage.removeItem(key)
                let xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        localStorage.setItem(key, xhr.response)
                    }
                }

                xhr.open("GET", this.$apiUrl + "Login.svc/carregar-regras-avisos");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send()
            },
            cleanAgendamentoLocal: function () {
                const storageKeys = Object.keys(localStorage)
                storageKeys.map(f => localStorage.removeItem(f))
            },
        }
    }

</script>
